import { render, staticRenderFns } from "./WlFormSidebar.vue?vue&type=template&id=197531ed"
import script from "./WlFormSidebar.vue?vue&type=script&lang=js"
export * from "./WlFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports